const currency2Number = v => Number(v.replace(/[^0-9.]+/g, ''))
export default currency2Number
